import { PermissionComponent } from "../../components";

export default function RoleDetailsPage() {
  return <PermissionComponent.RolesPage.RoleDetails />;
}
